import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Collapsible section with animated chevron.
 *
 * Props:
 *   title           string   — section header label
 *   defaultExpanded bool     — initial open/closed state (default: true)
 *   children        node     — content rendered inside when open
 *
 * State is local to the page — resets on navigation.
 * Do NOT persist to localStorage.
 */
export function CollapsibleSection({ title, defaultExpanded = true, children }) {
  const [open, setOpen] = useState(defaultExpanded);
  const slug = title.toLowerCase().replace(/\s+/g, '-');

  return (
    <div style={{ marginBottom: 20 }}>
      <button
        data-testid={`collapsible-${slug}`}
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          width: '100%', padding: '10px 16px',
          background: '#f8fafc',
          border: '1px solid #e2e8f0',
          borderRadius: open ? '8px 8px 0 0' : '8px',
          cursor: 'pointer',
          fontSize: 14, fontWeight: 700, color: '#0f172a',
          transition: 'border-radius 0.15s',
          textAlign: 'left',
        }}
      >
        <span>{title}</span>
        <ChevronDown
          size={16}
          style={{
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
            color: '#64748b',
            flexShrink: 0,
          }}
        />
      </button>
      {open && (
        <div
          data-testid={`collapsible-${slug}-content`}
          style={{
            border: '1px solid #e2e8f0',
            borderTop: 'none',
            borderRadius: '0 0 8px 8px',
            padding: 16,
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
